import { useTranslation } from 'react-i18next';

const SIZE = 140;
const STROKE = 12;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

function WordSplitDonut({ userWords = 0, aiWords = 0, size = SIZE, className = '' }) {
  const { t } = useTranslation();
  const total = userWords + aiWords;
  const userRatio = total > 0 ? userWords / total : 0;
  const aiRatio = total > 0 ? aiWords / total : 0;

  const userDash = userRatio * CIRCUMFERENCE;
  const aiDash = aiRatio * CIRCUMFERENCE;
  const center = size / 2;
  const scale = size / SIZE;
  const r = RADIUS;

  return (
    <div className={`donut-wrap ${className}`} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${SIZE} ${SIZE}`}>
        {/* Track */}
        <circle
          cx={SIZE / 2} cy={SIZE / 2} r={r}
          fill="none"
          stroke="rgba(255,255,255,0.04)"
          strokeWidth={STROKE}
        />
        {total > 0 ? (
          <>
            {/* User arc */}
            <circle
              cx={SIZE / 2} cy={SIZE / 2} r={r}
              fill="none"
              stroke="var(--color-accent, #d4a26a)"
              strokeWidth={STROKE}
              strokeDasharray={`${userDash} ${CIRCUMFERENCE - userDash}`}
              strokeDashoffset={CIRCUMFERENCE * 0.25}
              strokeLinecap="round"
              style={{ transition: 'stroke-dasharray 600ms ease' }}
            />
            {/* AI arc */}
            {aiRatio > 0 && (
              <circle
                cx={SIZE / 2} cy={SIZE / 2} r={r}
                fill="none"
                stroke="rgba(147, 197, 253, 0.5)"
                strokeWidth={STROKE}
                strokeDasharray={`${aiDash} ${CIRCUMFERENCE - aiDash}`}
                strokeDashoffset={CIRCUMFERENCE * 0.25 - userDash}
                strokeLinecap="round"
                style={{ transition: 'stroke-dasharray 600ms ease' }}
              />
            )}
          </>
        ) : null}
      </svg>
      <div className="donut-center">
        <strong>{total > 0 ? total.toLocaleString() : '0'}</strong>
        <span>{total > 0 ? t('rewards.donut.totalWords') : t('rewards.donut.startWriting')}</span>
      </div>
    </div>
  );
}

export default WordSplitDonut;
